import * as React from 'react';
import {observer} from 'mobx-react';
import {PageCheckoutPanelProps} from './page-checkout-panels';
import {CreditCards} from './credit-cards';
import {style} from 'typestyle';
import {PageCheckoutAddCard} from './page-checkout-add-card';
import {PageCheckoutAddress} from './page-checkout-address';
import {Alert} from './alert';
import {PageCheckoutVatNumber} from './page-checkout-vat-number';
import {mediaTablet} from '../theme/media';
import {important, px, rem} from 'csx';
import {AddressSchema} from '../types/schema';

export interface PageCheckoutContentStep1Props extends PageCheckoutPanelProps {
  onSelectCard(identity: string): void;
  onSelectAddress(address: AddressSchema): void;
  onChangeVatNumber?(vatNumber: string): void;
  onChangeCardForm(field: string, value: any): void;
  onAddCard(): void;
  i18n?: {
    titleSaved: string;
    titleAdd: string;
    titleAddress: string;
    titleVAT: string;
    noChargeTitle: string;
    noChargeContent: string;
  }
}

const DEFAULT_I18N = {
  titleSaved: 'Your saved cards',
  titleAdd: 'Add card',
  titleAddress: 'Billing address',
  titleVAT: 'VAT number',
  noChargeTitle: 'Please enter your card details',
  noChargeContent: 'We will not charge your card at this time.'
};

export const PageCheckoutContentStep1 = observer<PageCheckoutContentStep1Props>(
  ({ model, i18n = DEFAULT_I18N, onSelectCard, onAddCard, onChangeVatNumber, onChangeCardForm, onSelectAddress }) => {
    if (model.isBeta) return (
      <div className={styles.container}>
        {model.couponText && (
          <div className={styles.coupon}>
            <Alert title={model.couponText.title} type="warning" position="top-left">
              <p>{model.couponText.message}</p>
            </Alert>
          </div>
        )}
      </div>
    );

    return (
      <div className={styles.container}>
        {model.couponText && (
          <div className={styles.coupon}>
            <Alert title={model.couponText.title} type="warning" position="top-left">
              <p>{model.couponText.message}</p>
            </Alert>
          </div>
        )}
        <h5>{i18n.titleSaved}</h5>
        <CreditCards
          model={model}
          onSelectCard={onSelectCard}
          onAddCard={onAddCard}
        />
        {model.showNoChargeMessage && (
          <div>
            <Alert className={styles.noCharge} title={i18n.noChargeTitle} type="simple" position={null}>
              <p>{i18n.noChargeContent}</p>
            </Alert>
          </div>
        )}
        {model.showAddCard && (
          <h5>{i18n.titleAdd}</h5>
        )}
        {model.showAddCard && (
          <PageCheckoutAddCard
            model={model}
            onChange={onChangeCardForm}
          />
        )}
        {model.showAddCard && (
          <h5>{i18n.titleAddress}</h5>
        )}
        {model.showAddCard && (
          <PageCheckoutAddress
            address={model.address}
            addresses={model.addresses}
            addressError={model.addressError}
            onSelectAddress={onSelectAddress}
          />
        )}
        <h5>{i18n.titleVAT}</h5>
        <PageCheckoutVatNumber
          model={model.vatNumberForm}
          onChange={onChangeVatNumber}
        />
      </div>
    )
  }
);


const styles = {
  container: style({
    $nest: {
      '&> h5': {
        margin: '1.5rem 0'
      },
      '&> h5:first-child': {
        margin: '0 0 1.5rem 0'
      }
    }
  }),
  coupon: style(
    {
      marginBottom: rem(1.5)
    },
    mediaTablet({
      display: 'none'
    })
  ),
  noCharge: style(
    {
      margin: important('1.5rem 0'),
      $nest: {
        '& p': {
          margin: 0
        }
      }
    }
  )
};